<template>
  <!-- O singură rădăcină (dialogul e teleportat): clasele și stilurile scoped ale părintelui ajung pe link. -->
  <a ref="link" :href="href" @click.stop="handleClick" @auxclick.stop="handleAuxClick">
    <slot>{{ phone }}</slot>
    <NcrmPrivacyCallWarningDialog v-model="warningOpen" :phone="phone" @confirm="call" />
  </a>
</template>

<script>
import NcrmPrivacyCallWarningDialog from "@/components/ncrm/shared/NcrmPrivacyCallWarningDialog.vue";
import { CALL_CHECK_TIMEOUT_MS, fetchCallWarning, phoneDialer } from "@/Utile/ncrmPrivacyContactability.mjs";

// GDPR S9 (GDPR-122) — link `tel:` de pe fișe și din liste: la fiecare click (și click de mijloc) citește starea
// numărului și avertizează dacă are opoziție pe canalul telefon. O citire eșuată sună direct (avertizarea e
// informativă). Un click rămas în așteptare după schimbarea rândului sau demontare nu mai sună.
export default {
  name: "NcrmPrivacyPhoneLink",
  components: { NcrmPrivacyCallWarningDialog },
  props: {
    phone: { type: String, required: true },
    hrefValue: { type: String, default: "" }, // `tel:` deja curățat de apelant (fișa); implicit `tel:<phone>`
  },
  data() {
    return { warningOpen: false, checking: false, clickToken: 0, pendingHref: "" };
  },
  computed: {
    href() {
      return this.hrefValue || `tel:${this.phone}`;
    },
    targetKey() {
      return `${this.phone}:${this.href}`;
    },
  },
  watch: {
    targetKey() { this.reset(); },
    // La închiderea avertizării focusul revine pe numărul de telefon (tastatură).
    warningOpen(open, wasOpen) { if (!open && wasOpen) this.$nextTick(() => this.$refs.link?.focus?.({ preventScroll: true })); },
  },
  beforeUnmount() {
    this.reset();
  },
  methods: {
    reset() {
      this.clickToken += 1;
      this.checking = false;
      this.warningOpen = false;
    },
    handleAuxClick(event) {
      if (event.button === 1) this.handleClick(event);
    },
    async handleClick(event) {
      event.preventDefault();
      if (this.checking) return; // dublu-click: o singură verificare și un singur apel
      this.checking = true;
      const token = ++this.clickToken;
      const href = this.href;
      let warn = false;
      try { // exact numărul afișat, care se va forma
        warn = await fetchCallWarning(this.phone, undefined, { timeout: CALL_CHECK_TIMEOUT_MS });
      } catch {
        warn = false;
      }
      if (token !== this.clickToken) return; // rândul s-a schimbat sau componenta a fost demontată
      this.checking = false;
      this.pendingHref = href;
      if (warn) this.warningOpen = true;
      else this.call();
    },
    call() {
      const href = this.pendingHref || this.href;
      this.warningOpen = false;
      this.pendingHref = "";
      phoneDialer.dial(href);
    },
  },
};
</script>
